import {  html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { FormBase } from './formBase';
import "../custom-stepper";
@customElement('form-x')
export class FormX extends FormBase {
  static styles = css`
    .animate__animated {
      animation-duration: 0.7s;
    }
    
    .right-out-left-in-animation {
      animation-name: slideOutRight, slideInLeft;
    }
    
    .left-out-right-in-animation {
      animation-name: slideOutLeft, slideInRight;
    }
    
    @keyframes slideOutRight {
      from { transform: translateX(0); opacity: 1; }
      to { transform: translateX(100%); opacity: 0; }
    }
    
    @keyframes slideInLeft {
      from { transform: translateX(-100%); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
    
    @keyframes slideOutLeft {
      from { transform: translateX(0); opacity: 1; }
      to { transform: translateX(-100%); opacity: 0; }
    }
    
    @keyframes slideInRight {
      from { transform: translateX(100%); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
     /* Mobile navigation styles */
    .mobile-navigation {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      background-color: var(--md-sys-color-surface, #ffffff);
      box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
      border-top: 1px solid #e0e0e0;
      z-index: 1200;
      display: none;
      align-items: center;
      justify-content: space-around;
      padding: 0.5rem 0;
    }
    
    .mobile-nav-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 16px;
      padding: 8px 16px;
      position: relative;
      cursor: pointer;
      background-color: transparent;
      transition: all 0.3s ease;
    }
    
    .mobile-nav-item.active {
      background-color: rgba(123, 97, 255, 0.1);
    }
    
    .mobile-nav-icon {
      width: 24px;
      height: 24px;
      margin-bottom: 4px;
      transition: fill 0.3s ease;
    }
    
    .mobile-nav-label {
      font-size: 12px;
      font-weight: 500;
      transition: color 0.3s ease;
    }
    
    .mobile-nav-item.active .mobile-nav-label {
      font-weight: 600;
      color: var(--md-sys-color-primary, #7b61ff);
    }
    
    .mobile-nav-badge {
      position: absolute;
      top: 4px;
      right: 10px;
      background-color: red;
      color: white;
      font-size: 10px;
      font-weight: bold;
      border-radius: 50%;
      width: 18px;
      height: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
    }
    
    @media (min-width: 769px) {
      .mobile-navigation {
        display: none;
      }
    }
    
    /* Animation for active state */
    @keyframes navTap {
      0% { transform: scale(1); }
      50% { transform: scale(0.9); }
      100% { transform: scale(1); }
    }
    
    .mobile-nav-item:active {
      animation: navTap 0.2s ease;
    }
    
    .scrollbar-thin {
      scrollbar-width: thin;
    }
    
    .scrollbar-thin::-webkit-scrollbar {
      width: 6px;
    }
    
    .scrollbar-thumb-gray-400::-webkit-scrollbar-thumb {
      background-color: #9ca3af;
      border-radius: 3px;
    }
    
    .scrollbar-track-gray-100::-webkit-scrollbar-track {
      background-color: #f3f4f6;
    }
  `;

  @property({ type: Number }) pos = 0;
  @property({ type: Number }) maxPosReached = 0;
  @property({ type: String }) logo = '';
  @property({ type: String }) headerBgColor = '';
  @property({ type: String }) details = '';
  @property({ type: Boolean }) paymentsPage = false;
  @property({ type: String }) loading = 'false';
  @property({ type: String }) height = '';
  @property({ type: String }) maxHeight = '';
  @property({ type: Boolean }) isSectionPage = false;
  @property({ type: Array }) sections: any[] = [];
  @property({ type: Array }) oe: any[] = [];
  @property({ type: String }) template = '';
  @property({ type: String }) activeLayout = 'NENACALL';
  @property({ type: Array }) mobileNavigations: any[] = [];

  private _isMobile = false;

  firstUpdated() {
    this.setCardContentHeight();
    this.checkMobileView();
    window.addEventListener('resize', () => this.checkMobileView());
  }

    disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('resize', () => this.checkMobileView());
  }

  updated(changedProperties: Map<string, any>) {
    changedProperties.forEach((oldValue, propName) => {
      if (propName === "pos" && !isNaN(oldValue)) {
        this.positionTransition(oldValue);
      }
    });
  }

  checkMobileView() {
    this._isMobile = window.innerWidth <= 768;
    this.requestUpdate();
  }

  positionTransition(oldPosition: number) {
    const formXCard = this.shadowRoot?.querySelector(".form-x-card") as HTMLElement;
    if (!formXCard) return;

    const triggerTransition = (direction: string, oppositeDirection: string) => {
      formXCard.classList.add(`${direction}-out-${oppositeDirection}-in-animation`, 'animate__animated');

      setTimeout(() => {
        formXCard.classList.remove(`${direction}-out-${oppositeDirection}-in-animation`, 'animate__animated');
      }, 700);
    };
    
    if (this.pos > oldPosition) {
      triggerTransition("right", "left");
    }

    if (this.pos < oldPosition) {
      triggerTransition("left", "right");
    }
  }

  renderMobileNavigation() {
    if (!this._isMobile || window.TEMPLATE !== 'canvas') {
      return html``;
    }

    try {
      const details = {mobileNavigations:[{component:"NENACALL",label:"Main"},{component:"QUEUE PANEL",label:"queue"}]}

      if (!details?.mobileNavigations) {
        return html``;
      }

      // Filter mobile navigations to only include those that match oe items
      const filteredNavigations = details.mobileNavigations.filter((navItem: any) => {
        return this.oe.some(pageInput => 
          pageInput.__1?.toUpperCase() === navItem.component?.toUpperCase()
        );
      }).map((navItem: any) => {

        


        // Find the matching oe item to get the icon
        const matchingOeItem = this.oe.find(pageInput => 
          pageInput.__1?.toUpperCase() === navItem.component?.toUpperCase()
        );


        return {
          ...navItem,
          icon: matchingOeItem?.icon
        };
      });

      if (filteredNavigations.length === 0) {
        return html``;
      }

      return html`
        <div class="mobile-navigation">
          ${filteredNavigations.map((item: any, _index: number) => {
            const componentName = item.component;
            const isActive = this.activeLayout === componentName?.toUpperCase();
            
            return html`
              <div 
                class="mobile-nav-item ${isActive ? 'active' : ''}"
                @click=${(e: Event) => this.handleLayoutToggle(e, componentName)}
              >
                ${item.badgeCount > 0 ? html`
                  <div class="mobile-nav-badge">${item.badgeCount}</div>
                ` : ''}
                
                ${item.icon ? unsafeHTML(`
                  <adaptive-ui-icon 
                    class="mobile-nav-icon"
                    data-color="var(--primary-text)"
                    style="
                      fill: ${isActive ? 'var(--md-sys-color-primary)' : 'var(--md-sys-color-onSurfaceVariant)'};
                    "
                    icon="${item.icon}"
                  ></adaptive-ui-icon>
                `) : ''}
                
                <span class="mobile-nav-label">${item.label}</span>
              </div>
            `;
          })}
        </div>
      `;
    } catch (e) {
      console.error('Error parsing mobile navigations:', e);
      return html``;
    }
  }

  handleLayoutToggle(e: Event, layoutId: string) {
    e.preventDefault();
    e.stopPropagation();
    
    const newLayout = layoutId.toUpperCase();
    this.activeLayout = newLayout;
    
    // Dispatch event to handle layout changes in parent
    this.dispatchEvent(new CustomEvent('layout-change', {
      detail: { layoutId: newLayout },
      bubbles: true,
      composed: true
    }));
    
    // Show/hide elements based on layout
    this.oe.forEach((page) => {
      const id = page.__1?.toLowerCase();
      const element = document.getElementById(id);
      if (element) {
        element.style.display = id === layoutId.toLowerCase() ? 'block' : 'none';
      }
    });
  }

    private _onStepClick(event: CustomEvent<{ index: number }>): void {
    const index = event.detail.index;
    this._goToStep(index);
  }

  renderStepper() {
    // Use the custom stepper instead of the old one
    if (this.pos === 0 || this.maxPosReached < 1) {
      return html``;
    }

    const stepCount = this.maxPosReached + 1;
    const steps = Array.from({ length: stepCount });

    return html`
      <div class="stepper-container">
        <custom-stepper
          .steps="${steps}"
          .activeStep="${this.pos}"
          .currentStepLabel="${this.getStepLabel(this.pos)}"
          .feeds="${this.sections}"
          @step-click="${this._onStepClick}"
        ></custom-stepper>
      </div>
    `;
  }

  getStepLabel(index: number) {
    try {
      const details = JSON.parse(this.details);
      if (details.stepLabels && details.stepLabels[index]) {
        return details.stepLabels[index];
      }
    } catch (e) {
      // console.log('Could not parse details for step labels');
    }
    return `Step ${index + 1}`;
  }

// Update the render method in form-x.ts
render() {
  const cardStyle = this.paymentsPage ? 'shadow-none' : 'shadow-lg';

  return html`
    <div class="card form-x-card  form-card service ${cardStyle} bg-white rounded-lg border w-full border-gray-200 overflow-visible"> <!-- Changed overflow-hidden to overflow-visible -->
      ${this.checkLoading() ? html`
        <div class="overlay absolute inset-0 bg-white bg-opacity-70 z-10"></div>
      ` : html``}
      
      ${this.checkLoading() ? html`
        <div class="pro-container px-6 py-2">
          <div class="w-full bg-gray-200 rounded-full h-2">
            <div class="bg-blue-600 h-2 rounded-full animate-pulse"></div>
          </div>
        </div>
      ` : html``}
      
      <div class="card-content px-6 py-4 ${this.checkForDialog()} w-full">

        ${this.renderStepper()}

        <slot name="body"></slot>
      </div>
    </div>

      <!-- Mobile Navigation -->
      ${this.renderMobileNavigation()}

  `;
}

  setCardContentHeight() {
    let section = document.querySelector("section-page");

    if (this.maxHeight || this.height) {
      if (section != null && section.id == "dialog" && window.TEMPLATE == 'service') {
        const cardContent = this.shadowRoot?.querySelector(".card-content") as HTMLElement;
        if (cardContent) {
          if (this.height) cardContent.style.height = this.height;
          if (this.maxHeight) cardContent.style.maxHeight = this.maxHeight;
        }
      }
    }
  }

  // getForm() {
  //   const slot = this.shadowRoot?.querySelector('slot[name="body"]') as HTMLSlotElement | null;
  //   return slot?.assignedNodes()[0] ?? null;
  // }

  _notifyPosChange(newPos: number) {
    this.dispatchEvent(new CustomEvent('pos-change', {
      bubbles: true,
      composed: true,
      detail: { pos: newPos },
    }));
  }

  // _back(evt: Event) {
  //   this.pos -= 1;
  //   this._notifyPosChange(this.pos);
  // }

  // _forward(evt: Event) {
  //   this.pos += 1;
  //   this._notifyPosChange(this.pos);
  // }

  // _hideB(p: number, s: any[]) {
  //   return p === 0;
  // }

 _goToStep(index: number) {
  if (index < 0 || index >= this.sections.length) return;
  
  // Check if we're going backwards
  if (index < this.pos) {
    // Dispatch event that will trigger FormRender to clear future steps
    this.dispatchEvent(new CustomEvent('step-navigate-back', {
      bubbles: true,
      composed: true,
      detail: { newPos: index }
    }));
  }
  
  this.pos = index;
  this._notifyPosChange(this.pos);
}

  _hideF(p: number, s: any[]) {
    return p >= s.length - 1;
  }

  checkForDialog() {
    return this.isSectionPage ? "overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100" : "";
  }

  checkLoading() {    
    return this.loading === "true";
  }
}